"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function (builder, view) {
  return typeof builder === 'function' ? builder.apply(view) : builder;
};

exports.default = _default;